import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Daniela R.',
  city: 'Buenos Aires',
  plan: 'MegaPack + Método 12 Semanas',
  when: 'hace 3 minutos'
}, {
  name: 'Gustavo A.',
  city: 'Mendoza',
  plan: 'MegaPack Reconexión',
  when: 'hace 11 minutos'
}, {
  name: 'Verónica S.',
  city: 'Rosario',
  plan: 'MegaPack + Método 12 Semanas',
  when: 'hace 18 minutos'
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 20000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const purchase = purchases[index];
  return <AnimatePresence data-id="element-222" data-mp="286ac6btyh04p">
      {visible && !dismissed && <motion.aside aria-live="polite" initial={{
      opacity: 0,
      x: -16
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -16
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-30 hidden w-[320px] rounded-2xl border border-line bg-surface p-4 shadow-2xl sm:block" data-id="element-223" data-mp="284zbwlzpyaic">
          <div className="flex items-start gap-3" data-id="element-224" data-mp="1p7o9wtmpd2z7">
            <BadgeCheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-success" data-id="element-225" data-mp="1p996spwhoy08" />
            <div className="min-w-0" data-id="element-226" data-mp="rpxykzwdxma7">
              <p className="text-xs font-bold uppercase tracking-wide text-success" data-id="element-227" data-mp="wqlt3vjtol96">
                Compra verificada
              </p>
              <p className="mt-1 text-sm font-bold text-ivory" data-id="element-228" data-mp="200gdhmsbckp0">
                {purchase.name} de {purchase.city}
              </p>
              <p className="mt-0.5 text-sm text-muted" data-id="element-229" data-mp="28ubj0vxckd56">compró {purchase.plan}</p>
              <p className="mt-1 text-xs text-muted" data-id="element-230" data-mp="28wfjt4zy8w18">{purchase.when}</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="ml-auto rounded-md p-1 text-muted transition-colors duration-150 ease-soft hover:text-ivory focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-231" data-mp="24tj87y8tu06s">
              <XIcon aria-hidden="true" className="h-4 w-4" data-id="element-232" data-mp="1q4mqtakvrati" />
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}